import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/workspace/node_modules/nextjs-toploader/dist/index.js");
;
import(/* webpackMode: "eager", webpackExports: ["ToastContainer"] */ "/workspace/node_modules/react-toastify/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/workspace/public/css/global.scss");
;
import(/* webpackMode: "eager" */ "/workspace/node_modules/next/font/google/target.css?{\"path\":\"app/layout.js\",\"import\":\"Inter\",\"arguments\":[{\"subsets\":[\"latin\"],\"display\":\"swap\"}],\"variableName\":\"inter\"}");
;
import(/* webpackMode: "eager" */ "/workspace/node_modules/bootstrap/dist/css/bootstrap.min.css");
;
import(/* webpackMode: "eager" */ "/workspace/node_modules/bootstrap-icons/font/bootstrap-icons.css");
